import React, { FC } from 'react';
import classNames from 'classnames/bind';
import { STORE_ICONS_LINK } from 'constants';

import { Image } from '../../../Image';
import styles from './styles.pcss';

const cn = classNames.bind(styles);

export const AppIconsBlock: FC = () => (
  <div className={cn('container')}>
    {STORE_ICONS_LINK?.map((src, index) => (
      <div className={cn('wrap')} key={index}>
        <Image className={cn('image')} height={20} src={src} width={20} />
      </div>
    ))}
  </div>
);
